import React from 'react';
import { ShoppingBagIcon } from './Icons';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <div className="header-content">
        <div className="header-right">
          <button className="cart-button">
            <ShoppingBagIcon />
          </button>
        </div>
        <div className="greeting">
          <h1>Hey, Kev!</h1>
        </div>
      </div>
    </header>
  );
};

export default Header; 